import styled from 'styled-components';
import {
    HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS,
    FONT_PROPERTIES,
    BORDER_PROPERTIES,
    FOCUS_CSS,
    BACKGROUND_PROPERTIES,
} from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const LinkOutContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    height: 100%;
    width: 100%;
    align-items: center;
    justify-content: center;
    padding: 1rem;

    ${BACKGROUND_PROPERTIES}
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const LinkOutHeadline = styled.h2`
    text-align: center;

    ${FONT_PROPERTIES}
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const LinkOutButton = styled.a`
    display: inline-block;
    padding: 0.75rem 1.5rem;
    background-color: ${(props) => props.$backgroundColor};
    word-break: break-word;
    text-align: center;
    border-style: solid;

    ${FONT_PROPERTIES}
    ${BORDER_PROPERTIES}
    ${FOCUS_CSS}

    &:hover {
        background-color: ${(props) => props.$backgroundColorHover};
        color: ${(props) => props.$fontColorHover};
        border-color: ${(props) => props.$borderColorHover};
    }

    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;
